import { ReactNode } from 'react';

const BulkActions = ({ children }: { children: ReactNode }) => {
  return (
    <div className="sticky flex items-center justify-center top-16 -translate-y-1/2 z-30">
      <div className="bg-white px-2 py-2 rounded-xl shadow-md flex items-center justify-center gap-2">{children}</div>
    </div>
  );
};

export default BulkActions;
